<template>
  <div class="position_relative">
    <div class="padding_content" id="padding_junk" style="padding-bottom: 80px;">
      <div id="junk_container">
        <div class="junk_selection">
          <!-- <img src="../../assets/img/search-wifi.png" alt="" /> -->
          <h3>{{ $t('junk.junkService') }}</h3>
          <p>{{ $t('junk.func1') }}</p>
          <p>{{ $t('junk.func2') }}</p>
          <p>{{ $t('junk.func3') }}</p>
          <p>{{ $t('junk.func4') }}</p>
          <p>{{ $t('junk.func5') }}</p>
          <p>{{ $t('junk.func6') }}</p>
          <p>{{ $t('junk.func7') }}</p>
        </div>
        <div class="better_suits">
          <h3 class="choose">{{ $t('service.screenshot') }}</h3>
          <div class="screenshot">
              <img class="img" src="../../assets/img/junk-scan.png">
          </div>
        </div>
        <div class="junk_api">
          <h3 class="choose">{{ $t('service.choose') }}</h3>
          <div class="better_suits">
            <p>{{ $t('service.apiLevel') }}</p>
            <div class="single_product">
              <div class="product_li">
                <h3 class="title">{{ $t('junk.free') }}</h3>
                <p class="way">{{ $t('service.monthly') }}</p>
                <div class="description">
                  <p>{{ $t('junk.desc1') }}</p>
                  <p>{{ $t('junk.desc2') }}</p>
                  <p>{{ $t('junk.desc3') }}</p>
                  <p>{{ $t('junk.desc4') }}</p>
                  <p>{{ $t('junk.desc5') }}</p>
                </div>
                <div class="select_btn" @click="jump('/support')">{{ $t('service.download') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <serviceFooter @scale="scale" :service="service"></serviceFooter>
    <loading :show="loading"></loading>
  </div>
</template>

<script>
  import { downAPP } from '../public/validator'
  import serviceFooter from './footer'
  import VueRouter from 'vue-router'

  const { isNavigationFailure, NavigationFailureType } = VueRouter
  export default {
    name: 'Junk Clean',
    components: { serviceFooter },
    data() {
      return {
        product: {},
        loading: true,
        service: 'junk'
      }
    },
    methods: {
      jump(url) {
        this.$router.push(url).catch(err => {
          // to hide the below error message
          if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
            throw Error(err)
          }
        })
      }
    },
    mounted() {
      downAPP('padding_junk', '180px')
    }
  }
</script>

<style lang="scss" src="./service.scss" scoped></style>
<style lang="scss" scoped>
  .junk_selection {
    height: 320px;
    @include border-radius(6px);
    background: $white;
    position: relative;
    text-align: center;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
    & > h3 {
      width: 100%;
      height: 24px;
      font-size: 20px;
      font-family: NexaBold;
      color: rgba(31, 37, 62, 1);
      line-height: 24px;
      padding: 40px 0 17px;
    }
    & > img {
      width: 140px;
      height: 140px;
      @include absolute-left-top(0, 0);
    }
    .color_gray {
      height: 19px;
      font-size: 16px;
      font-family: NexaLight;
      font-weight: 400;
      color: rgba(31, 37, 62, 0.7);
      line-height: 19px;
      margin-bottom: 33px;
    }
    & > p {
      height: 30px;
      font-size: 14px;
      font-family: Lato-Regular;
      font-weight: 500;
      color: rgba(31, 37, 62, 0.9);
      line-height: 30px;
    }
  }
  .product_li .title {
    height: 48px;
    font-size: 40px;
    font-family: Lato-Bold;
    font-weight: bold;
    color: rgba(31, 37, 62, 1);
    line-height: 48px;
    padding: 36px 0 4px;
    text-align: center;
  }

  @media screen and (max-width: 450px) {
    .junk_selection {
      & > img {
        width: 60px;
        height: 60px;
      }
      & > h3 {
        font-size: 14px;
        padding: 40px 0 4px;
      }

      .color_gray {
        font-size: 12px;
      }

      & > p {
        font-size: 12px;
      }
    }
    .product_li .title {
      font-size: 32px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/service/junk.vue